import { render } from "./Renderer.vue?vue&type=template&id=11c930f6&lang=pug"
import script from "./Renderer.vue?vue&type=script&setup=true&lang=js"
export * from "./Renderer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__